import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '@app/store/store.state';
import { clearState } from '@app/store/store.actions';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClearStateService {
  private _clearState$ = new Subject<void>();

  constructor(private _store: Store<State>) {}

  clearState() {
    this._clearState$.next();
    this._store.dispatch(clearState());
  }

  get clearState$() {
    return this._clearState$;
  }
}
